import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';

import { EventModel, EventScoreboard, KeyValuePairScoreboard, LeaderboardGameScore, Weather } from '@frontend/sports/betting-offer/feature/model';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { ParticipantImageComponent } from '@frontend/sports/participant-image/feature';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { FavouriteEventToggleComponent } from '../../favourites/toggle/favourite-event-toggle.component';
import { EventTimerComponent } from '../../timers/event-timer.component';

@Component({
    selector: 'ms-leaderboard-game-scoreboard',
    templateUrl: 'leaderboard-game-scoreboard.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, ParticipantImageComponent, FavouriteEventToggleComponent, EventTimerComponent, IconCustomComponent],
})
export class LeaderboardGameScoreboardComponent implements OnChanges {
    sportType = SportConstant;
    @Input() event: EventModel;
    @Input() scoreboard: EventScoreboard;
    @Input() isNewEDPScoreboard = false;

    @HostBinding('class') className = 'leaderboard-game';

    private sportsWithLaps = [SportConstant.Formula1, SportConstant.Motorbikes];
    score: LeaderboardGameScore;
    displayLaps: boolean;
    weather: Weather | null;
    players: KeyValuePairScoreboard[];

    ngOnChanges(): void {
        const shouldLapsDisplayForSport = this.sportsWithLaps.includes(this.event.sport.id);
        this.score = this.event.scoreboard.getScore<LeaderboardGameScore>()!;
        this.displayLaps = shouldLapsDisplayForSport && !this.score.preRace;
        this.weather = this.score.weather;
        this.players = this.score.participantsDetails.slice(0, 10);
    }
}
